import { useState, JSX } from 'react';
import {
    Edit,
    useRecordContext
} from 'react-admin';
import { NokEditForm } from "./components/Noks/NokEditForm";
import { NokEditEmails } from "./components/Noks/NokEditEmails";
import {
    Box,
    Chip,
    Stack,
    Tab,
    Tabs
} from '@mui/material';
import { useGetEmailCountForNok } from "../global-hooks/new-email-counter";
import { NokWebsite } from '../../types/entities';
import { numeric } from '../dashboard/components/styles/dashboard-tokens';

/**
 * The Emails tab's name, with the count of new emails beside it when there are any: the same tab
 * label as the Queues page, so a zero is never shown.
 */
const EmailsTabLabel: () => JSX.Element = (): JSX.Element => {
    const record: NokWebsite = useRecordContext();
    const { newEmailCount, isLoading } = useGetEmailCountForNok(record?.url);

    return (
        <Stack direction="row" alignItems="center" spacing={ 1 }>
            <span>{ "Emails" }</span>
            { (!isLoading && newEmailCount > 0) &&
                <Chip size="small" color="primary" label={ newEmailCount } aria-label={ `${ newEmailCount } new` } sx={ { height: 18, ...numeric } } />
            }
        </Stack>
    );
}

export const NokWebsiteEdit: () => JSX.Element = (): JSX.Element => {
    const [activeTab, setActiveTab] = useState<number>(0);

   function handleTabClick(num: number) {
       setActiveTab(num);
   }

    return (
        <Edit redirect={ false }>
            <Box sx={ { borderBottom: 1, borderColor: 'divider' } }>
                <Tabs value={ activeTab }
                      onChange={ (_event: unknown, next: number): void => handleTabClick(next) }
                      aria-label="Nok website sections">
                    <Tab value={ 0 } label="Configuration" id="nok-website-tab-configuration" aria-controls="nok-website-panel-configuration" />
                    <Tab value={ 1 } label={ <EmailsTabLabel /> } id="nok-website-tab-emails" aria-controls="nok-website-panel-emails" />
                </Tabs>
            </Box>
            { (activeTab === 0) &&
                <Box role="tabpanel" id="nok-website-panel-configuration" aria-labelledby="nok-website-tab-configuration">
                    <NokEditForm />
                </Box>
            }
            { (activeTab === 1) &&
                <Box role="tabpanel" id="nok-website-panel-emails" aria-labelledby="nok-website-tab-emails" sx={ { p: 2 } }>
                    <NokEditEmails />
                </Box>
            }
        </Edit>
    );
}
